import { ErrorModalTypes } from '@Store/index';
import { OnboardingFormFields } from '@Types/index';
import { Icons } from '@Components/icon/Icon.tsx';
import { ErrorType } from '@Services/errors/errorType.ts';
import type { IErrorHandling } from '@Types/index';

export const BusinessErrorMap = {
  BUSINESS_NAME_ILLEGAL_NAME: { errorCode: 80003, errorType: ErrorType.BUSINESS_LOGIC },
  LLC_INVALID_EIN: { errorCode: 80004, errorType: ErrorType.BUSINESS_LOGIC },
  LLC_INVALID_STATE: { errorCode: 80005, errorType: ErrorType.BUSINESS_LOGIC },
  EIN_IS_NOT_SSN: { errorCode: 80010, errorType: ErrorType.BUSINESS_LOGIC },
  EIN_ALREADY_EXISTS: { errorCode: 80012, errorType: ErrorType.BUSINESS_LOGIC },
  EIN_ALREADY_USED_BY_SAME_USER: { errorCode: 80014, errorType: ErrorType.BUSINESS_LOGIC },
  EIN_NOT_UNIQUE: { errorCode: 80013, errorType: ErrorType.BUSINESS_LOGIC },
  BUSINESS_EIN_REAPPLICATION_TIME_RESTRICTION: {
    errorCode: 50851,
    errorType: ErrorType.BUSINESS_LOGIC,
  },
  OWNERSHIP_PERCENT_NOT_VALID: { errorCode: 90223, errorType: ErrorType.BUSINESS_LOGIC },
};

export const getBusinessErrorsObjectMap = (): Map<number, IErrorHandling> => {
  return new Map<number, IErrorHandling>([
    [
      BusinessErrorMap.BUSINESS_NAME_ILLEGAL_NAME.errorCode,
      {
        errorCode: BusinessErrorMap.BUSINESS_NAME_ILLEGAL_NAME.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.BUSINESS_NAME,
        callBack: () => {},
      },
    ],
    [
      BusinessErrorMap.LLC_INVALID_EIN.errorCode,
      {
        errorCode: BusinessErrorMap.LLC_INVALID_EIN.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.BUSINESS_EIN,
        callBack: () => {},
      },
    ],
    [
      BusinessErrorMap.LLC_INVALID_STATE.errorCode,
      {
        errorCode: BusinessErrorMap.LLC_INVALID_STATE.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.BUSINESS_REGISTER_STATE,
        callBack: () => {},
      },
    ],
    [
      BusinessErrorMap.EIN_IS_NOT_SSN.errorCode,
      {
        errorCode: BusinessErrorMap.EIN_IS_NOT_SSN.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.BUSINESS_EIN,
        callBack: () => {},
      },
    ],
    [
      BusinessErrorMap.EIN_ALREADY_EXISTS.errorCode,
      {
        errorCode: BusinessErrorMap.EIN_ALREADY_EXISTS.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.BUSINESS_EIN,
        callBack: () => {},
      },
    ],
    [
      BusinessErrorMap.EIN_ALREADY_USED_BY_SAME_USER.errorCode,
      {
        errorCode: BusinessErrorMap.EIN_ALREADY_USED_BY_SAME_USER.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.BUSINESS_EIN,
        callBack: () => {},
      },
    ],
    [
      BusinessErrorMap.EIN_NOT_UNIQUE.errorCode,
      {
        errorCode: BusinessErrorMap.EIN_NOT_UNIQUE.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.BUSINESS_EIN,
        callBack: () => {},
      },
    ],
    [
      BusinessErrorMap.BUSINESS_EIN_REAPPLICATION_TIME_RESTRICTION.errorCode,
      {
        errorCode: BusinessErrorMap.BUSINESS_EIN_REAPPLICATION_TIME_RESTRICTION.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.BUSINESS_EIN,
        callBack: () => {},
      },
    ],
    [
      BusinessErrorMap.OWNERSHIP_PERCENT_NOT_VALID.errorCode,
      {
        errorCode: BusinessErrorMap.OWNERSHIP_PERCENT_NOT_VALID.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.OWNER_PERCENTAGE,
        callBack: () => {},
      },
    ],
    // EIN reapplication restriction - user cannot submit a new application with this EIN yet (LC-28809).
    // No redirect: keep the user on the current page instead of ejecting them from onboarding.
    [
      BusinessErrorMap.BUSINESS_EIN_REAPPLICATION_TIME_RESTRICTION.errorCode,
      {
        errorCode: BusinessErrorMap.BUSINESS_EIN_REAPPLICATION_TIME_RESTRICTION.errorCode,
        redirectPath: '',
        callBack: () => {},
        openModal: true,
        modalProps: {
          type: ErrorModalTypes.GENERAL,
          title: "We're unable to process a new application for this business EIN right now.",
          content: 'You may be eligible to reapply in the future.',
          icon: Icons.Oops,
          buttonText: 'Close',
        },
      },
    ],
  ]);
};
